// Renders a narrative (HTML limited to <strong>/<em>/<u>/<br>) as React elements — never
// dangerouslySetInnerHTML. The string is parsed with DOMParser (inert: nothing executes or
// loads) and walked; only those four tags are kept, everything else collapses to its text.

import React, { useMemo } from 'react';

function toNodes(parent, keyPrefix) {
  const out = [];
  parent.childNodes.forEach((n, i) => {
    const key = `${keyPrefix}${i}`;
    if (n.nodeType === 3) { out.push(n.nodeValue); return; }
    if (n.nodeType !== 1) return;
    const tag = n.tagName;
    if (tag === 'BR') { out.push(<br key={key} />); return; }
    const kids = toNodes(n, `${key}.`);
    if (tag === 'STRONG' || tag === 'B') out.push(<strong key={key}>{kids}</strong>);
    else if (tag === 'EM' || tag === 'I') out.push(<em key={key}>{kids}</em>);
    else if (tag === 'U') out.push(<u key={key}>{kids}</u>);
    else out.push(<React.Fragment key={key}>{kids}</React.Fragment>);
  });
  return out;
}

export default function NarrativeHtml({ html, className }) {
  const nodes = useMemo(() => {
    if (!html) return null;
    const body = new DOMParser().parseFromString(String(html), 'text/html').body;
    return toNodes(body, '');
  }, [html]);
  return <span className={className}>{nodes}</span>;
}
